import { Injectable } from '@angular/core';
import { HTTP,HTTPResponse } from '@ionic-native/http';
import { ConfigurationManager } from './ConfigurationManager';
import * as Constants from './Constants';

@Injectable()
export class TabsProviderService {


    all_deals_encoded = 'All Deals';


    constructor(private http: HTTP, private config: ConfigurationManager) { }


    getchildTabsNative(ScreenTitle: string) {



        if (ScreenTitle === Constants.ONLINE.params.name) {
            ScreenTitle = this.all_deals_encoded;
        }

        const headers = {
            'Content-Type': 'application/json',
            'x-api-key': this.config.environmentConfig.apikey,
            'Accept': 'application/json'
        };

        const params = {
            'Latitude': this.config.getLatitude + '',
            'Longitude': this.config.getLongitude + '',
            'SessionID': this.config.getSessionId,
            'ScreenTitle': ScreenTitle,
            'ProxyUI': this.config.getProxyUI,
            'ClubID': this.config.getClubCode,
            'FromNewDNR': 'true',
        };

        return this.http.get(this.config.environmentConfig.baseurl + 'setyp/v1', params, headers);

    }



}
